import React, { FunctionComponent } from 'react'
import { observer } from 'mobx-react-lite'
import Dropdown, { IListItem } from './Dropdown'
import { BoldText } from './Text'
import { colors } from '../styles/_var'
import { ICategory } from '../utils/interfaces'


interface ICompetitionCategoryDropdown {
  selectedCategory?: ICategory
  categories: ICategory[]
  onSelectCategory: (category: ICategory) => void
}

const CompetitionCategoryDropdown: FunctionComponent<ICompetitionCategoryDropdown> = ({
  selectedCategory,
  categories,
  onSelectCategory
}) => {
  const dropdownList = categories.map(e => ({ label: e.name, value: `${e.id}` }))
  const selected = {label: selectedCategory?.name || '', value: selectedCategory?.id?.toString() || ''}
  const selectCategory = (category: IListItem) => {
    onSelectCategory({id: +category.value, name: category.label})
  }

  return (
    <div>
      <BoldText variant='small' color={colors.purple} ml={1}>Categories</BoldText>
      <Dropdown 
        style={{minWidth: '270px'}}
        list={dropdownList}
        selected={selected}
        onItemSelect={e => selectCategory(e)}
        returnFullObject
      />
    </div>
  )
}

export default observer(CompetitionCategoryDropdown)
